import React, { Fragment, useState } from 'react'
import NewOrgModal from './NewOrgModal'
import OrgTable from './OrgTable'

const TableContainer = () => {
  const [newOrgModalOpen, toggleModal] = useState(false)

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <a
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            href="/account/admin_homepage/-/"
          >
            <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
          </a>
          <div
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
            onClick={() => toggleModal(!newOrgModalOpen)}
          >
            <div className="far fa-plus fa-fw mr-2" /> Add New Organization
          </div>
        </div>
        <h3>Organizations</h3>
        <div className="mb-2">
          <span>Config URL: </span>
        </div>
        <div className="mb-2">
          <code>
            https://app.myeducator.com/links/canvas_connect.xml_config
          </code>
        </div>
        <OrgTable />
      </div>
      <NewOrgModal show={newOrgModalOpen} toggle={toggleModal} />
    </Fragment>
  )
}

export default TableContainer
